<template>
  <div class="section">
    <header-page>
      <span class="text-dark fw-bold-700 size14">Retur</span>
    </header-page>
    <div class="transaction__filter--container py-2 pl-0 pr-2">
      <b-button-group>
        <b-button v-for="(item, index) in listFilter" :id="`button--filter${index}`" :key="`${item}-${index}`"
          class="filter--button" :class="{ 'active': item == filter }" @click="handleFilterClick(item)"
          :disabled="isLoading">
          {{ item }}
        </b-button>
      </b-button-group>
      <div class="d-flex search__export">
        <FilterButton @filterBase="getFilterBase" :isRetur="true" />
      </div>
    </div>

    <TableReturPenjualan v-if="filter == 'Retur Penjualan'" :results="resultsReturSelling" :get-data="getData"
      :is-loading="isLoading" :type-retur="filter" @filter="getFilter" />
    <TableReturPembelian v-if="filter == 'Retur Pembelian'" :results="resultsReturPurchase" :get-data="getData"
      :is-loading="isLoading" :type-retur="filter" @filter="getFilter" />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash'
import {
  BButton, BButtonGroup, VBToggle,
} from 'bootstrap-vue'
import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
import HeaderPage from '@/components/HeaderPage.vue'
import TableReturPenjualan from '@/components/Retur/TableReturPenjualan.vue'
import TableReturPembelian from '@/components/Retur/TableReturPembelian.vue'
// import ModalRetur from '@/components/Retur/Modal/ModalRetur.vue'
import FilterButton from '@/components/BaseFilter.vue'
// import Invoice from '@/components/InvoiceComponent.vue'

export default {
  title() {
    return 'Retur'
  },
  components: {
    BButton,
    HeaderPage,
    BButtonGroup,
    TableReturPenjualan,
    // ModalRetur,
    FilterButton,
    // Invoice,
    TableReturPembelian,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  setup() {
    return {
      checkPermission, successNotification, errorNotification,
    }
  },
  data() {
    return {
      listFilter: ['Retur Penjualan', 'Retur Pembelian'],
      filter: 'Retur Penjualan',
      comp: 'TableReturPenjualan',
      isEdit: false,
      filters: {
        search: '',
        per_page: 10,
        sort_type: 'desc',
        // type: 'order',
      },
      resultsReturSelling: {},
      resultsReturPurchase: {},
      filterBase: {},
      isLoading: false,
    }
  },
  created() {
    const returType = this.$route.query.returType;

    // Decide filter based on query
    if (returType === 'retur_selling') {
      this.filter = 'Retur Penjualan';
    } else if (returType === 'retur_purchasing') {
      this.filter = 'Retur Pembelian';
    }

    // Always fetch after deciding filter
    this.getData(parseInt(this.$route.query.page || 1));
  },
  watch: {
    filter(value) {
      if (value === 'Retur Penjualan' || value === 'Retur Pembelian') {
        this.filters.search = '';
      }
      if (value === 'Retur Penjualan') {
        this.getData(parseInt(this.$route.query.page || 1));
      }
      if (value === 'Retur Pembelian') {
        this.getData(parseInt(this.$route.query.page || 1));
      }
    },
    filters: {
      handler: _.debounce(function () {
        this.getData(parseInt(this.$route.query.page || 1))
      }, 300),
      deep: true,
    },
    filterBase: {
      handler: _.debounce(function () {
        this.getData(parseInt(this.$route.query.page || 1))
      }, 300),
      deep: true,
    },
  },
  mounted() {
    if (this.$route.query.returType === 'retur_selling') {
      this.filter = 'Retur Penjualan'
      this.getData()
    }
    if (this.$route.query.returType === 'retur_purchasing') {
      this.filter = 'Retur Pembelian'
      this.getData()
    }
  },
  methods: {
    handleFilterClick(item) {
      this.filter = item;
      this.comp = item === 'Retur Penjualan' ? 'TableReturPenjualan' : 'TableReturPembelian';

      // Reset page to 1 by removing page param from URL entirely
      const query = { ...this.$route.query };
      delete query.page;

      this.$router.replace({ query });

      // Force load page 1
      this.getData(1);
    },
    getFilterBase(value) {
      this.filterBase = value
    },
    getFilter(value) {
      this.filters = value
    },
    async getData(page) {
      this.isLoading = true;

      let queryParams = {
        ...this.filters,
        status: this.filterBase.status,
        filter_date_type: this.filterBase.filter_date_type,
        filter_date_value: this.filterBase.filter_date_value,
        page: page || parseInt(this.$route.query.page || 1),
        type: this.filter === 'Retur Penjualan' ? 'order' : 'incoming_stock',
      };

      if (['retur_selling', 'retur_purchasing'].includes(this.$route.query.returType)) {
        queryParams.petty_cash_uuid = this.$route.query.petty_cash_uuid;
      } else {
        delete queryParams.petty_cash_uuid
      }

      try {
        const result = await this.$store.dispatch('returs/getData', {
          uuid: '',
          params: queryParams,
        });

        // Update router query with current page only (and preserve others)
        const currentPage = parseInt(this.$route.query.page || 1);
        const newPage = queryParams.page;

        if (newPage !== currentPage) {
          this.$router.replace({
            query: {
              ...this.$route.query,
              page: newPage,
            },
          });
        }

        if (this.filter === 'Retur Penjualan') {
          this.resultsReturSelling = result.data.data;
        } else {
          this.resultsReturPurchase = result.data.data;
        }
      } catch (err) {
        this.isLoading = false
        //eslint-disable-next-line no-console
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    getIsEdit(val) {
      this.isEdit = val
      this.$bvModal.show('modal-retur')
    },
    postIsEdit() {
      this.isEdit = false
      this.$bvModal.show('modal-retur')
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
